import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { DollarSign, Users, UserMinus } from 'lucide-react';

export default function AdminInstructorsTab({ instructors, selectedInstructor, user, onSelect, onEditRate, onManageChildren, onRemove }) {
  return (
    <div className="grid gap-4" data-testid="admin-instructors-tab">
      {instructors.map(inst => (
        <Card key={inst.user_id} className={`rounded-2xl border-slate-100 shadow-sm cursor-pointer transition-all hover:shadow-md ${selectedInstructor?.user_id === inst.user_id ? 'ring-2 ring-[#22D3EE]' : ''}`} onClick={() => onSelect(inst)} data-testid={`instructor-card-${inst.user_id}`}>
          <CardContent className="p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#1E1B4B] to-[#2D2B66] flex items-center justify-center text-white font-bold text-lg shrink-0" style={{ fontFamily: 'Nunito' }}>{inst.name?.charAt(0) || '?'}</div>
              <div>
                <p className="font-bold text-slate-800">{inst.name || inst.email}</p>
                <p className="text-sm text-slate-500">{inst.email}</p>
                <div className="flex gap-2 mt-1">
                  <Badge variant="outline" className="rounded-full text-xs">{inst.children_count} students</Badge>
                  <Badge variant="outline" className="rounded-full text-xs">${inst.pay_rate || 37.5}/hr</Badge>
                </div>
              </div>
            </div>
            <div className="flex gap-2 flex-wrap">
              <Button size="sm" variant="outline" className="rounded-xl text-xs font-semibold gap-1" onClick={(e) => { e.stopPropagation(); onEditRate(inst); }} data-testid={`edit-rate-${inst.user_id}`}>
                <DollarSign className="w-3 h-3" /> Rate
              </Button>
              <Button size="sm" variant="outline" className="rounded-xl text-xs font-semibold gap-1" onClick={(e) => { e.stopPropagation(); onManageChildren(inst); }} data-testid={`manage-children-${inst.user_id}`}>
                <Users className="w-3 h-3" /> Children
              </Button>
              {inst.user_id !== user?.user_id && (
                <Button size="sm" variant="outline" className="rounded-xl text-xs font-semibold gap-1 text-red-500 border-red-200 hover:bg-red-50" onClick={(e) => { e.stopPropagation(); onRemove(inst); }} data-testid={`remove-instructor-${inst.user_id}`}>
                  <UserMinus className="w-3 h-3" /> Remove
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
